import { Facility } from '../Entities/Facility';
import { queryGetFacility } from '../Queries';

export const facilityQueryFields = [
    'id',
    'uid',
    'facility_name',
    'timezone',
    'accessSystem',
];

const facilityInSessionStorage = (facilityId) => {
    if (!facilityId) return false;

    const facility = JSON.parse(window.sessionStorage.facility ?? null);
    return facility?.uid === facilityId;
};

/**
 * Retrieves the facility from session storage or else queries the db
 * @param   {string}    facilityId
 * @returns {Promise<Facility>}
 */
export const getFacility = async (facilityId) => {
    if (facilityInSessionStorage(facilityId)) {
        const facility = JSON.parse(window.sessionStorage.facility);
        return Facility.createFromQueryValues(facility);
    }

    const response = await queryGetFacility({ facility_id: facilityId}, facilityQueryFields);
    if (response.errors) {
        throw response.errors;
    }

    const facility = response.data.getFacility;
    window.sessionStorage.facility = JSON.stringify(facility);

    return Facility.createFromQueryValues(facility);
};
